export default "__VITE_ASSET__BPGML5_4__"